import moment from 'moment';

class LeadStageHistory {
    constructor(json) {
        if (json != null) {
            this.id = json.id;
            this.customerId = json.customerId;
            this.fromStage = json.fromStage != null ? json.fromStage : json.from_stage;
            this.toStage = json.toStage != null ? json.toStage : json.to_stage;
            this.changedAt = moment
                .utc(json.changedAt != null ? json.changedAt : json.changed_at)
                .local();
            this.changedByUserId = json.changedByUserId != null ? json.changedByUserId : json.changed_by_user_id;
        }
    }
}

export default LeadStageHistory;
